import {createReducer} from '@reduxjs/toolkit'
import {HttpError} from '@wix/http-client'
import {AnyAction} from 'redux'
import {cancelReservation, clearReservation, clearReservationError, makeReservation} from '../actions/reservation'
import {RESERVATION_ERROR} from '../constants'
import {Reservation} from '../types/state'

const defaultState: Reservation = {
  data: null,
  error: null,
}

export const reservation = createReducer(defaultState, builder => {
  builder
    .addCase(makeReservation.fulfilled, (state, action) => {
      state.error = null
      state.data = action.payload
    })
    .addCase(cancelReservation.fulfilled, state => {
      state.data = null
      state.error = null
    })
    .addCase(makeReservation.rejected, (state, action: AnyAction) => {
      const error: HttpError = action.payload

      state.data = null
      state.error = error?.response?.data?.details?.applicationError?.code ?? RESERVATION_ERROR.SOMETHING_WENT_WRONG
    })
    .addCase(clearReservation, () => {
      return defaultState
    })
    .addCase(clearReservationError, state => {
      state.error = null
    })
})
